import { notFound } from '@tanstack/react-router'

interface ActualVsBudgetEnvironment {
  VITE_ACTUAL_VS_BUDGET_MOCK_ENABLED?: string
}

export function isActualVsBudgetMockEnabled(
  environment: ActualVsBudgetEnvironment
) {
  return environment.VITE_ACTUAL_VS_BUDGET_MOCK_ENABLED === 'true'
}

export function requireActualVsBudgetMockAccess(
  _routeContext: unknown,
  environment: ActualVsBudgetEnvironment = import.meta.env
) {
  if (!isActualVsBudgetMockEnabled(environment)) {
    throw notFound()
  }
}
